import AttendPayslipImportLayout from './AttendPayslipImportLayout';

export default AttendPayslipImportLayout;
